import React from 'react';
import { Phone, Mail, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { siteData } from '../mock/data';
import ScrollReveal from './ScrollReveal';

const ContactBlock = () => {
  const { company } = siteData;
  return (
    <section className="section bg-[#EFE9DE]">
      <div className="container-x">
        <div className="grid md:grid-cols-12 gap-12 items-end">
          <div className="md:col-span-7">
            <ScrollReveal>
              <div className="font-mono-up text-[#0A2A28]/60 mb-6">
                <span className="gold-line" />Kontakt aufnehmen
              </div>
            </ScrollReveal>
            <ScrollReveal delay={1}>
              <h2 className="font-display text-6xl md:text-8xl leading-[0.95] text-[#0A2A28]">
                Sprechen Sie <br />
                <span className="font-serif-italic text-[#BFA070]">mit uns.</span>
              </h2>
            </ScrollReveal>
            <ScrollReveal delay={2} className="mt-8">
              <p className="max-w-xl text-[#0A2A28]/75 text-lg leading-relaxed">
                Nehmen Sie gerne Kontakt mit uns auf. Ob telefonisch, per E‑Mail oder über das Kontaktformular – wir freuen uns, von Ihnen zu hören.
              </p>
            </ScrollReveal>
          </div>

          <div className="md:col-span-5 space-y-8">
            <ScrollReveal delay={2}>
              <a href={`tel:${company.phoneHref}`} className="block group border-t border-[#0A2A28]/15 pt-6">
                <div className="font-mono-up text-[#0A2A28]/55 mb-3">Anrufen</div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4 font-display text-3xl md:text-4xl text-[#0A2A28] group-hover:text-[#BFA070] transition-colors">
                    <Phone size={22} strokeWidth={1.25} />
                    <span>{company.phone}</span>
                  </div>
                  <ArrowUpRight size={22} strokeWidth={1.25} className="text-[#0A2A28]/60 group-hover:text-[#BFA070] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                </div>
              </a>
            </ScrollReveal>
            <ScrollReveal delay={3}>
              <a href={`mailto:${company.email}`} className="block group border-t border-[#0A2A28]/15 pt-6">
                <div className="font-mono-up text-[#0A2A28]/55 mb-3">Schreiben</div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4 font-display text-3xl md:text-4xl text-[#0A2A28] group-hover:text-[#BFA070] transition-colors">
                    <Mail size={22} strokeWidth={1.25} />
                    <span>{company.email}</span>
                  </div>
                  <ArrowUpRight size={22} strokeWidth={1.25} className="text-[#0A2A28]/60 group-hover:text-[#BFA070] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                </div>
              </a>
            </ScrollReveal>
            <ScrollReveal delay={4}>
              <Link to="/kontakt" className="lux-btn">
                <span>Zum Kontaktformular</span>
                <ArrowUpRight className="arrow" size={16} strokeWidth={1.5} />
              </Link>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactBlock;
